<script setup>
import { useSeoMeta } from '@unhead/vue'
import { useGlobalStore } from '@stores/global'
import GlobalHero from '@sections/global/Hero.vue'
import Intro from '@sections/about/Intro.vue'
import CrownsTicker from '@sections/global/CrownsTicker.vue'
import Visionaries from '@sections/about/Visionaries.vue'
import TearDivider from '@components/global/accents/TearDivider.vue'
import Awards from '@sections/about/Awards.vue'
import Clients from '@sections/global/Clients.vue'
import Contact from '@sections/global/Contact.vue'

const global = useGlobalStore()

useSeoMeta({
	title: () => global.pages.find((page) => page.path === 'about')?.title ?? global.pages.find((page) => page.path === '/')?.title,
	description: () => global.pages.find((page) => page.path === 'about')?.description ?? global.pages.find((page) => page.path === '/')?.description,
	image: () => global.pages.find((page) => page.path === 'about')?.image ?? global.pages.find((page) => page.path === '/')?.image,
})
</script>

<template>
	<main>
		<GlobalHero :rive="{ src: 'https://cdn.papercrowns.com/website/rive/lockups/about.riv', height: 512, width: 1570 }" titleSvg="https://cdn.papercrowns.com/website/images/elements/lockups/about.svg" />
		<Intro />
		<CrownsTicker background="#111111" />
		<!-- <Visionaries /> -->
		<TearDivider paper="#111111" background="#080808" />
		<Awards />
		<TearDivider paper="#080808" background="#111111" />
		<Clients />
		<Contact />
	</main>
</template>
